import type { VenueContact, IContactData } from "../../types/venues.types";

export const mapVenueContactToContactData = (
  contact: VenueContact,
): IContactData => ({
  id: contact.id,
  contact_type: "individual",
  first_name: contact.first_name,
  last_name: contact.last_name,
  email: contact.email,
  phone: contact.phone,
  address_one: "",
  address_two: "",
  suburb: "",
  city: "",
  country: "",
  website: "",
  notes: "",
  facebook_profile: "",
  instagram_profile: "",
  twitter_profile: "",
  linkedin_profile: "",
  contact_image: null,
  contactImageFile: null,
});

export const mapContactDataToVenueContact = (
  contact: IContactData,
  venueId: number,
): VenueContact => ({
  id: contact.id,
  first_name: contact.first_name,
  last_name: contact.last_name,
  email: contact.email,
  phone: contact.phone,
  twitter_handle: null,
  instagram_handle: null,
  facebook_handle: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  venue: venueId,
});

export const formatTitle = (type: string): string =>
  type
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const SEARCH_MIN_CHARS = 3;
export const SEARCH_DEBOUNCE_MS = 500;

export const DOCUMENT_TYPES = [
  "venue_photos",
  "pa_system",
  "equipment",
  "floor_plan",
] as const;
